<template>
    <div>
        <v-text-field
                v-model="sensor"
                :label="label|translate"
                class="cursor-as-pointer"
                readonly
                v-on:click="openDiag()"
                :clearable="clearable"
        >
                <template v-slot:append>
                    <v-icon v-on:click="openDiag()" class="cursor-as-pointer">fa-caret-down</v-icon>
                </template>
        </v-text-field>
        <v-dialog
                v-model="dialog"
                width="500"
        >
            <v-card v-if="dialog">
                <v-sheet class="pa-3 primary lighten-2">
                    <v-text-field ref="afsearchfield"
                            v-model="search"
                            :label="'Search'|translate"
                            flat
                            solo-inverted
                            hide-details
                            clearable
                    ></v-text-field>
                </v-sheet>
                <v-card-text>
                    <v-treeview v-if="equipTree"
                                :search="search"
                                :items="equipTree"
                                activatable
                                item-key="id"
                                :filter="customSearch"
                                open-on-click
                    >
                        <template v-slot:label="{ item }">
                        <span v-if="item.children.length==0">
                                    <v-chip v-on:click="selectItem(item)">
                                        <span style="cursor: pointer;">{{item.name}}<span v-if="item.desc">&nbsp;-&nbsp;{{item.desc}}</span></span>
                                    </v-chip>
                        </span>
                            <span v-if="item.children.length>0">{{item.name}}</span>
                        </template>
                    </v-treeview>
                </v-card-text>
            </v-card>

        </v-dialog>

    </div>
</template>

<script>
    import {sortFloors} from '@/helper'
  export default {
    name: 'SensorSelector',
    props: {
      value: String,
      typeFilter: {type: String, default: null},
      label: {type: String, default: "Sensor"},
      clearable: {type: Boolean, default: false},
    },
    watch: {
      value () {
        if(this.sensor!==this.value){
          this.sensor = this.value
        }
      },
      sensor (newSensor) {
        this.$emit('input', newSensor)
      },
        dialog (dialog) {
          let me=this
            if(dialog){
                setTimeout(function(){
                    me.$refs.afsearchfield.$el.querySelector('input').focus()
                },300)

            }
      },
    },
      mounted () {
          if (!!this.value) {
              this.sensor = this.value
          }
      },

    data () {
      return {
        sensor: null,
          childrenList:{},
          search:null,
          dialog:false,
          open:[],
          typeMap:{}
      }
    },
      methods: {
          customSearch(item,text){
              return (item.name&&item.name.toLowerCase().indexOf(text.toLowerCase())>-1)||(item.desc&&item.desc.toLowerCase&&item.desc.toLowerCase().indexOf(text.toLowerCase())>-1)
          },
        selectItem(item){
            this.sensor=item.equipment_name+" - "+item.name
            this.dialog=false
        },
          openDiag() {
              this.search = null
              this.open = [];
              this.dialog = true
          },
          findWhere(array, key, value) {
              let t = 0;
              while (t < array.length && array[t][key] !== value) {
                  t++;
              }
              if (t < array.length) {
                  return array[t]
              } else {
                  return false;
              }
          },
          arrangeIntoTree(paths) {
              let tree = [];
              for (let i = 0; i < paths.length; i++) {
                  let path = paths[i];
                  let currentLevel = tree;
                  for (let j = 0; j < path.length; j++) {
                      let part = path[j];
                      let existingPath = this.findWhere(currentLevel, 'name', part);
                      if (existingPath) {
                          currentLevel = existingPath.children;
                      } else {
                          let newPart = {
                              name: part,
                              id: path.join('-')+'-'+part,
                              children: [],
                          }
                          if(this.childrenList[part]){
                              newPart.children=[...this.childrenList[part]]
                          }
                          currentLevel.push(newPart);
                          currentLevel = newPart.children;
                      }
                  }
              }
              return tree;
          }
      },
      computed: {
          selectSensor() {
              let output = []
              if (!this.$store.state.pointsListStore.pointsList) return [{id: 1, name: 'loading'}]
              let descMap={}
              for (let item of this.$store.state.pointsListStore.pointsList.points_list){
                  if(item.sensor_desc&&item.sensor_desc!==""){
                      descMap[item.equipment_name+" - "+item.sensor_name]=item.sensor_desc
                  }
              }
              let id = 1
              for (let i in this.$store.state.pointsListStore.pointsList.sensors) {
                  let points = []
                  let current = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                  for (let j in this.$store.state.pointsListStore.pointsList.sensors[i]) {
                      let key=this.$store.state.pointsListStore.pointsList.equipment_details[i].equipment_name+" - "+this.$store.state.pointsListStore.pointsList.sensors[i][j]
                      points.push({
                          id: id,
                          children: [],
                          name: this.$store.state.pointsListStore.pointsList.sensors[i][j],
                          equipment_name: this.$store.state.pointsListStore.pointsList.equipment_details[i].equipment_name,
                          facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                          desc:descMap[key] ? descMap[key] : null
                      })
                      id++
                  }
                  points.sort((a, b) => (a.name > b.name) ? 1 : -1)
                  this.childrenList[current.equipment_name] = points
                  output.push(current)
              }
              output.sort((a, b) => (a.equipment_name > b.equipment_name) ? 1 : -1)
              return output
          },
          equipTree(){
              let equipList=this.selectSensor;
              let equipPaths=[];
              for (let equip of equipList){
                  let newPath=[]
                  if(equip.floor&&equip.floor!==""&&equip.floor!=="NaN"){
                      if (equip.floor.startsWith(".")&&this.$store.state.userStore.user.content.role!=="admin"){
                          continue
                      }
                      newPath=equip.floor.split('>').concat([equip.equipment_name])
                  } else if (equip.equipment_type&&equip.equipment_type!==""&&equip.equipment_type!==equip.equipment_name){
                      newPath=[equip.equipment_type,equip.equipment_name]
                  } else {
                      newPath=[equip.equipment_name]
                  }
                  if(newPath.length>1){
                      for (let index=0; index<newPath.length; index++){
                          if(index<newPath.length&&newPath[index]===newPath[index+1]){
                              newPath[index]=newPath[index]+" "
                          }
                      }
                  }
                  equipPaths.push(newPath)
              }
              equipPaths=sortFloors(equipPaths)
              let tree=this.arrangeIntoTree(equipPaths);
              return tree;
          }
      }
  }
</script>

